<template>
  <div class="crud_module--rsr_cancel_charger">
    <el-button v-if="checkStatus()" type="info" @click="rsrStopCharger"><fa :icon="['fas', 'ban']"/></el-button>
  </div>
</template>

<script>
export default {
  props: ["data"],
  components: {
    
  },
  async beforeMount() {
    this.key = this.$route.params.key;
    this.id = this.$route.params.id;
  },
  methods: {
    checkStatus(){
      if(this.data?.status == 'RemoteStarted'){
        return true;
      }
      return false;
    },
    async rsrStopCharger() {
      await this.$axios.get(`/${this.key}/cancel/${this.data.rsr_id}`, {}).then(res=>{
        if(res.data?.status == "success"){
          this.$message({
            message: this.$t("success"),
            type: 'success'
          });
        }
        else if(res.data?.status == "error"){
          this.$message({
            message: this.$t(`error.${res.data?.errorCode}`),
            type: 'error'
          });
        }
        else {
          this.$message({
            message: this.$t("error.generic"),
            type: 'error'
          });
        }
      }).catch(err=>{
        this.$message({
            message: this.$t("error.generic"),
            type: 'error'
        });
        return false;
      });
    },
  },
  data() {
    return {
      key: "",
      id:0,
      loading:false,
      connectors:[],
      input:{
        connectorId:0,
        duration:0,
        startCode:"",
        lp:"",
        entryTime:""
      },
    }
  }
}
</script>

<style lang="scss">
.crud_module--rsr_cancel_charger{
    .el-button--info{
        padding: 7px;
    }
    
//   display:inline-block;
//   margin-top: 10px;
//   margin-left: 10px;
//   .el-button--info{
//     background-color: #909399;
//   }
}
</style>